import { render, staticRenderFns } from "./CircleNavigationItem.vue?vue&type=template&id=c8543506&"
import script from "./CircleNavigationItem.vue?vue&type=script&lang=js&"
export * from "./CircleNavigationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports